
export default {
  inform(type: string, title: string, message?: string): Promise<void> {
    return Promise.resolve();
  },
  alert(title: string, message: string, options?: { noFocus?: boolean, fireworks?: boolean }): Promise<void> {
    return Promise.resolve();
  },
  confirm(title: string, message: string, options?: { yesNo?: boolean }): Promise<boolean> {
    return Promise.resolve(false);
  },
  prompt(title: string, message: string, options?: { placeholder?: string }): Promise<string> {
    return Promise.resolve('');
  },
}
